import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { Decorator } from "components"

import Quote from "./_Quote"

function QuoteList({ decorators, quotes }) {
  return (
    <section data-slice="QuoteList" className="pt-32 pb-30 md:py-24 wrapper">
      <div className="relative default-grid">
        <div className="relative -mx-6 sm:-mx-fluidMargin col-span-full md:mx-0 xl:col-span-10 xl:col-start-2 bg-lightBlue">
          <ul className="px-6 space-y-6 sm:px-fluidMargin md:space-y-8 md:px-18 py-14">
            {quotes?.map((item, i) => (
              <Quote {...item} index={i} key={`quoteListItem--${i}`} />
            ))}
          </ul>
          <div
            className="absolute top-0 right-0 hidden w-px transform -translate-y-24 md:block bg-mineralGray"
            style={{ height: 480 }}
          />
        </div>

        <div className="quote-list__texture-1">
          <div className="aspect-w-2 aspect-h-3 xl:aspect-w-16 xl:aspect-h-9 ring-1 ring-mineralGray">
            <StaticImage
              src="../../../assets/product-categories/jelly.jpg"
              placeholder="blurred"
              width={420}
              alt="Jelly very close"
              objectFit="cover"
              objectPosition="center"
              backgroundColor="#8e426c"
              style={{ position: "absolute" }}
            />
          </div>
        </div>

        <div
          className="absolute top-0 hidden h-px origin-left md:-right-fluidMargin xl:right-0 md:block bg-mineralGray"
          style={{ width: "34.25%" }}
        />

        {decorators && decorators[0] && (
          <Decorator
            className="absolute left-0 -translate-y-full md:-translate-x-2/3 xl:translate-x-0 top-14 md:top-0 md:translate-y-0"
            asset={decorators && decorators[0].asset}
            size="small"
          />
        )}
        {decorators && decorators[1] && (
          <Decorator
            className="absolute bottom-0 right-0 translate-x-1/2 translate-y-18 md:translate-y-1/3 md:translate-x-1/4 xl:-translate-x-1/4"
            asset={decorators && decorators[1].asset}
            size="small"
          />
        )}
      </div>
    </section>
  )
}

export default QuoteList
